import { Box, Grid } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

import { EventsSection } from "@utilifeed/components/propai";
import { usePropAiFlexStationEventLog } from "@core/apis/PropAI/hooks";

const EventsPage = () => {
  const { substationId } = Route.useParams();
  const { data: events, isLoading } = usePropAiFlexStationEventLog(substationId);

  return (
    <Box p={4}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <EventsSection events={events} isLoading={isLoading} />
        </Grid>
      </Grid>
    </Box>
  );
};

export const Route = createFileRoute("/$organizationId/properties/$substationId/events")({
  component: EventsPage,
});
